import styled from "styled-components";
import { padding, rgba } from "polished";
const DropdownMenuItemImpl = styled("div")(
  ({ theme }) => ({
    background: "none",
    border: 0,
    boxSizing: "border-box",
    cursor: "pointer",
    color: theme.color.gray8,
    display: "block",
    fontFamily: theme.fontFamily.default,
    fontSize: theme.fontSize.default,
    fontWeight: theme.fontWeight.normal,
    lineHeight: theme.lineHeight.default,
    outline: 0,
    overflow: "hidden",
    ...padding(4, 8),
    textAlign: "left",
    textDecoration: "none",
    textOverflow: "ellipsis",
    transition: "all 0.1s cubic-bezier(.645, .045, .355, 1)",
    whiteSpace: "nowrap"
  }),
  ({ $appearance }) => ({
    neat: {
      borderRadius: 1
    },
    round: {
      borderRadius: 2
    }
  })[$appearance],
  ({ $inSection }) => $inSection ? {
    paddingLeft: 16
  } : null,
  ({ $magnitude }) => ({
    small: {
      ...padding(2, null)
    },
    medium: {
      ...padding(4, null)
    },
    large: {
      ...padding(6, null)
    }
  })[$magnitude],
  ({ disabled, variant, theme }) => {
    if (disabled)
      return {
        background: "none",
        color: theme.color.gray6,
        fontWeight: "initial",
        pointerEvents: "none",
        "&:focus": {
          boxShadow: "none"
        }
      };
    if (!variant)
      return {
        "&:hover": {
          backgroundColor: theme.color.gray3,
          color: theme.color.gray8,
          zIndex: 1
        },
        "&:active": {
          backgroundColor: theme.color.gray4
        },
        "&:focus": {
          boxShadow: `0 0 0 2px ${rgba("black", 0.05)}`
        }
      };
    return {
      accent: {
        fontWeight: theme.fontWeight.medium,
        backgroundColor: theme.color.blue1,
        color: theme.color.blue6,
        "&:hover": {
          backgroundColor: theme.color.blue2
        },
        "&:focus": {
          zIndex: 1,
          boxShadow: `0 0 0 2px ${rgba(theme.color.blue6, 0.25)}`
        },
        "&:active": {
          backgroundColor: theme.color.blue3
        }
      },
      danger: {
        color: theme.color.red6,
        "&:hover": {
          backgroundColor: theme.color.red1
        },
        "&:focus": {
          zIndex: 1,
          boxShadow: `0 0 0 2px ${rgba(theme.color.red6, 0.25)}`
        },
        "&:active": {
          backgroundColor: theme.color.red2
        }
      }
    }[variant];
  }
);
export {
  DropdownMenuItemImpl
};
